import React from "react";
import { useForm, Controller } from "react-hook-form";
import { FileDropzone, Icon, TutorialContainer } from "../../../_components";

export function DefaultCoverPage({ onSubmit, store, formRef, tooltipID }) {
  const { control, handleSubmit } = useForm({
    defaultValues: {
      cover: store.cover || null,
    },
  });
  return (
    <div className="chronos-default-cover-page">
      {/* GIF */}
      <TutorialContainer
        type="video"
        url="https://wa-cdn.nyc3.cdn.digitaloceanspaces.com/chronos/748d8a7f-93ee-48a7-985e-62615090b002.webm"
      />
      <form ref={formRef} onSubmit={handleSubmit(onSubmit)}>
        <div className="content-page-wrapper">
          <h2 className="chronos-wizard-page-title">Choose your Cover Image</h2>
          <p className="chronos-wizard-text">
            This image will appear as a default cover for your events. If you
            have no map, it will also appear as the background of your
            chronicle.&nbsp;
            <Icon
              icon="fas fa-question-circle fa-fw"
              data-for={tooltipID}
              data-tip={`Suggested: 1920x1080 pixels, webp or jpg`}
            />
          </p>

          <div className="form-group">
            <Controller
              control={control}
              name="cover"
              id="cover"
              render={({ value, onChange }) => (
                <FileDropzone
                  value={value}
                  onChange={onChange}
                  className="chronos-file-dropzone"
                />
              )}
            />
          </div>
        </div>
      </form>
    </div>
  );
}
